import { cn } from '@reflex/ui/lib/utils';

export type StatusTintTone = 'info' | 'warning' | 'success' | 'error';

/** Background, text, and hover tint for chips and tinted outline controls. */
export function statusTintSurface(tone: StatusTintTone): string {
  return cn(
    tone === 'info' && 'bg-status-info/10 text-status-info hover:bg-status-info/20',
    tone === 'warning' && 'bg-status-warning/10 text-status-warning hover:bg-status-warning/20',
    tone === 'success' && 'bg-status-success/10 text-status-success hover:bg-status-success/20',
    tone === 'error' && 'bg-status-error/10 text-status-error hover:bg-status-error/20',
  );
}

/**
 * Pill layout (inline-flex, padding, text size) plus {@link statusTintSurface}.
 * Use for links; compose {@link statusTintSurface} with Button sizing when using shadcn Button.
 */
export function statusTintChip(
  tone: StatusTintTone,
  size: 'sm' | 'md' = 'sm',
  className?: string,
): string {
  return cn(
    'inline-flex items-center gap-1.5 rounded-md px-2.5 text-xs font-medium transition-colors',
    size === 'md' ? 'py-1.5' : 'py-1',
    statusTintSurface(tone),
    className,
  );
}
